import { render } from "./employees-header.vue?vue&type=template&id=5c479785"
import script from "./employees-header.vue?vue&type=script&lang=js"
export * from "./employees-header.vue?vue&type=script&lang=js"

import "./employees-header.vue?vue&type=style&index=0&id=5c479785&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__